module.exports = __webpack_public_path__ + "img/stellar.4bf0b4b9.png";